import * as PIXI from "pixi.js";
import {pixiComponents} from "../index"
import {cpConfigs} from "./configs";
import {handleSpinButton, spinControlPanel} from "../slotBoard/spin";
import {updateSpinBtnState} from "./index";
import {freeBetsStore, freeSpinStore, spinStore} from "../store";
import {freeBetGame} from "../freeBetGame";
import {showErrorToast} from "../notifications/toastNotificatons/toastNotification";
import {t, TKeys} from "../translationService";
import {gsap} from "gsap";
import {universalClick} from "../utilites";
import {isMobile, Sprite, Texture} from "pixi.js";
import {SmoothGraphics} from "@pixi/graphics-smooth";

const autoSpinCounts = [10, 20, 50, 100];

export const hideAutoBetSelector = () => {
    pixiComponents.cpItems.autoBetSelector.visible = false;
}

export const showAutoBetSelector = () => {
    pixiComponents.cpItems.autoBetSelector.visible = !pixiComponents.cpItems.autoBetSelector.visible;
    pixiComponents.cpItems.autoBetSelector.scale.y =  0.3;
    gsap.to(pixiComponents.cpItems.autoBetSelector.scale, {
        y: 1,
        x: 1,
        duration: 0.2,
    });
}

export const uiConfig = {
    width: cpConfigs.btnSize2.width*0.92,
    height: 0,
    buttonSize: cpConfigs.btnSize2.width/1.5,
    textStyle: {
        fontFamily: 'BebasNeue',
        fontSize: isMobile.phone ? 36:29,
        fill: 0xffffff,
    }
}

export const addAutoBetSelector = () => {
    uiConfig.height = (autoSpinCounts.length + 1) * uiConfig.buttonSize;

    const autoBetSelectorContainer = new PIXI.Container();
    autoBetSelectorContainer.visible = false;

    autoBetSelectorContainer.pivot.y = uiConfig.height;

    autoBetSelectorContainer.x = cpConfigs.autoSpinBtn.x - uiConfig.width / 2;
    autoBetSelectorContainer.y = cpConfigs.autoSpinBtn.y - cpConfigs.autoSpinBtn.height / 2 + 13;

    autoBetSelectorContainer.addChild(addBgAutoBetSelector());

    autoSpinCounts.forEach((count, index) => {
        autoBetSelectorContainer.addChild(choseAutoSpinCountBtn(count, uiConfig.width / 2, uiConfig.buttonSize + index * uiConfig.buttonSize))
    })

    return autoBetSelectorContainer;
}

export const addBgAutoBetSelector = () => {
    const bgContainer = new PIXI.Graphics();

    const rect = new PIXI.Graphics();
    rect.beginFill("rgba(0,0,0,0.0001)");
    rect.drawRect(-1500, -1500, 3000, 3000);
    rect.endFill();
    rect.eventMode = 'static';
    universalClick(rect, hideAutoBetSelector)

    const bgSprite = new Sprite(Texture.from("autoSpinMenuBg.png"));
    bgSprite.width = uiConfig.width;
    bgSprite.height = uiConfig.height * 0.97;

    bgSprite.y = uiConfig.height * 0.03;

    bgContainer.addChild(rect, bgSprite);

    return bgContainer;
}

const choseAutoSpinCountBtn = (count, x, y) => {
    const countText = new PIXI.Text(count, uiConfig.textStyle);
    countText.anchor.set(0.5);
    countText.x = x;
    countText.y = y;

    countText.cursor = 'pointer';
    countText.eventMode = "static";
    universalClick(countText, () => {
        hideAutoBetSelector();
        startAutoSpin(limitCountToFreeBets(count) - 1);
    });

    return countText;
}

// During a free bet game the player can not spin more times than the free bets
// left, so the chosen auto spin count is capped to that amount.
const limitCountToFreeBets = (count) => {
    if (!freeBetGame.isFreeBetSpin()) {
        return count;
    }

    const leftCount = freeBetsStore.getFreeBetLeftCount();

    if (!leftCount || leftCount >= count) {
        return count;
    }

    showErrorToast(`${t(TKeys.FREE_BETS_LEFT)}: ${leftCount}`);

    return leftCount;
}

export const startAutoSpin = (countAutoSpins) => {
    spinStore.setAutoSpinCountdown(countAutoSpins);
    if(spinControlPanel.isAutoSpinning){
        return;
    }
    spinControlPanel.isAutoSpinning = true;
    updateSpinBtnState(spinControlPanel);
    handleSpinButton();
}

export const continueAutoSpin = () => {
    if(!spinStore.autoSpinCountdown){
        return;
    }
    spinControlPanel.isAutoSpinning = true;
    updateSpinBtnState(spinControlPanel);
    handleSpinButton();
}

export const stopAutoSpin = () => {
    spinControlPanel.isAutoSpinning = false;
    spinStore.setAutoSpinCountdown(0);
    updateSpinBtnState(spinControlPanel);
    handleSpinButton();
}

export const setAutoSpinBtnCountdownNumber = (number) => pixiComponents.cpItems.stopAutoSpinBtn.countdownText.text = number;